<template>
  <BaseCardV2
    :has-eq-height="false"
    :server-error="erreurParam"
    has-help
    titre="Mes paramètres d'exploitation"
    @on-help="isOpenModalHelp = true"
  >
    <div v-if="isFormulaire">
      <v-row>
        <v-col>
          <ParametresExploitationFormulaire
            :loading-params="loadingParam"
            :parametres-exploitation="parametresExploitationModifiable"
            @change="onParamExploitationChange($event)"
          />
        </v-col>
      </v-row>
      <div class="d-flex justify-center mx-5 mb-5">
        <AgrButton
          :disabled="isEnregistrementDisabled"
          class="px-12"
          color="primary"
          large
          @click="onSave"
        >
          Enregistrer
        </AgrButton>
      </div>
    </div>
    <div v-else>
      <v-row>
        <v-col>
          <ParametresExploitationRestitution
            :erreur="erreurParam"
            :loading="loadingParam"
            :parametres-exploitation="parametresExploitationModifiable"
          />
        </v-col>
      </v-row>
      <div class="d-flex justify-center mx-5 mb-5">
        <AgrButton
          class="px-12"
          color="primary"
          large
          outlined
          @click="isFormulaire = true"
        >
          Modifier
        </AgrButton>
      </div>
    </div>
    <HelpModal
      v-if="isOpenModalHelp"
      titre="mes paramètres d'exploitation"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>
            Les caractéristiques de votre exploitation sont utiles pour vous comparer au sein du réseau AGRIAL.
            Tant qu'elles ne sont pas complétées, vous ne pourrez profiter pleinement de toutes les fonctionnalités de l’application.
          </p>
        </div>
      </div>
    </HelpModal>
  </BaseCardV2>
</template>
<script>
import {AgrButton} from '@agrial/ui'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import {clone} from '@/utils/clone'
import {mapActions, mapGetters} from 'vuex'
import ParametresExploitationFormulaire from '@/views/compte/components/formulaire-param-exploitation.vue'
import ParametresExploitationRestitution from '@/views/compte/components/restitution-param-exploitation.vue'

export default {
  name: 'ParametresExploitation',
  components: { ParametresExploitationRestitution, ParametresExploitationFormulaire, AgrButton, BaseCardV2, HelpModal },
  data () {
    return {
      loadingParam: false,
      erreurParam: false,
      parametresExploitationModifiable: {},
      isOpenModalHelp: false,
      isFormulaire: true
    }
  },
  computed: {
    ...mapGetters({
      parametresExploitation: 'parametresExploitation/parametresExploitation',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet'
    }),

    isEnregistrementDisabled () {
      return this.loadingParam || !this.isFormulaire ||
        this.parametresExploitationModifiable.typeExploitation == null || this.parametresExploitationModifiable.typeExploitation.code === 'INCONNU' ||
        this.parametresExploitationModifiable.typeSol == null || this.parametresExploitationModifiable.typeSol.code === 'INCONNU' ||
        ((this.parametresExploitationModifiable.profondeurSol == null || this.parametresExploitationModifiable.profondeurSol < 30 || this.parametresExploitationModifiable.profondeurSol > 180)) ||
        this.parametresExploitationModifiable.typeProduction == null || this.parametresExploitationModifiable.typeProduction.code === 'INCONNU' ||
        this.parametresExploitationModifiable.ressourceEffluent == null || this.parametresExploitationModifiable.ressourceEffluent.code === 'INCONNU' ||
        this.parametresExploitationModifiable.stockageCereales == null || this.parametresExploitationModifiable.stockageCereales.code === 'INCONNU' ||
        (this.parametresExploitationModifiable.stockageCereales.code === 'VENTE' && this.parametresExploitationModifiable.capaciteStockage == null)
    },
  },

  watch: {
    parametresExploitation () {
      this.parametresExploitationModifiable = clone(this.parametresExploitation)
    }
  },
  
  created () {
    this.loadParametresExploitation()
  },

  methods: {
    ...mapActions({
      getParametresExploitation: 'parametresExploitation/getParametresExploitation',
      getParametresExploitationComplet: 'parametresExploitation/getParametresExploitationComplet',
      createOrUpdateParametresExploitation: 'parametresExploitation/createOrUpdateParametresExploitation',
      getProfondeurSolParDefaut: 'parametresExploitation/getProfondeurSolParDefaut',
    }),

    loadParametresExploitation () {
      this.loadingParam = true
      this.erreurParam = false

      this.getParametresExploitation()
        .then(() => {
          this.parametresExploitationModifiable = clone(this.parametresExploitation)
          this.loadIsParametresExploitationComplet()
        })
        .catch(() => {
          this.erreurParam = true
        })
        .finally(() => {
          this.loadingParam = false
        })
    },

    loadIsParametresExploitationComplet () {
      this.loadingParam = true
      this.erreurParam = false

      this.getParametresExploitationComplet()
        .then(() => {
          this.isFormulaire = !this.isParametresExploitationComplet
        })
        .catch(() => {
          this.erreurParam = true
        })
        .finally(() => {
          this.loadingParam = false
        })
    },

    onParamExploitationChange (newParametre) {
      this.parametresExploitationModifiable = newParametre
    },

    onSave () {
      this.updateParametreExploitation()
      this.isFormulaire = false
    },

    updateParametreExploitation () {
      this.loadingParam = true
      this.erreurParam = false

      if (this.parametresExploitationModifiable.stockageCereales.code !== 'VENTE') {
        this.parametresExploitationModifiable.capaciteStockage = null
      }
      this.createOrUpdateParametresExploitation(this.parametresExploitationModifiable)
        .then(() => {
          this.loadIsParametresExploitationComplet()
        })
        .catch(() => {
          this.erreurParam = true
        })
        .finally(() => {
          this.loadingParam = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
